import { concat, get } from 'lodash';
import React, { FC } from 'react';
import SummaryLine from '../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
import { enumT } from '../../../../../../utils/helper';
import AbschlussSeiteBox from '../../../antrag-components/AbschlussSeiteBox';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import AenderungAnfrageSchema from '../../../../../../lib/paths/aenderungsanfrage_FULL_Paths.json';
const P = AenderungAnfrageSchema.attributes;

const AbschlussAenderungAnfrage: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Abschluss" description={PLATZHALTER_TEXT} />
			<AbschlussSeiteBox>
				<SummaryLine
					label="Art der Änderung"
					value={get(application, P.Aenderungsanfrage_Begruendung_Des_Antragstellers_Aenderungsart.path, ['-'])
						.map((ele: any) => enumT(ele))
						.join(',  ')}
				/>
				<SummaryLine label="Begründung" value={get(application, P.Aenderungsanfrage_Begruendung_Des_Antragstellers_Begruendung.path, '-')} />
			</AbschlussSeiteBox>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default AbschlussAenderungAnfrage;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Aenderungsanfrage_Begruendung_Des_Antragstellers_Anlagen,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAbschlussAenderungAnfrage = () => {
	return concat(formStruc());
};
